<template>
  <form class="mt-4"
        @submit.prevent="updateTermsData">
    <div class="row justify-content-start mb-2">
      <div class="col-md-12 col-sm-12">
        <h4>{{ $t('ManageSystemView.termsAndConditionsSettings') }}</h4>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col col-md-12 col-sm-12 form-group mb-4">
        <textarea class="form-control w-100 h-100"
                  v-model="termsAndConditions"
                  rows="5"
                  cols="30">
        </textarea>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col col-md-6 col-sm-12 form-group">
        <button type="submit"
                class="btn btn-success rounded-pill mb-4 w-100">
          <i class="bi bi-plus-circle"></i> {{ $t('save') }}
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import {getAllSettings, putSettings} from "@/utils";

export default {
  data() {
    return {
      termsAndConditions: "",
    }
  },
  async mounted() {
    let response = await getAllSettings();
    if (response.status === 200) {
      this.termsAndConditions = response.data.terms_and_conditions;
    } else {
      this.message = response.response.data.message;
      this.messageType = "danger";
    }
  },
  methods: {
    async updateTermsData() {
      await putSettings({'terms_and_conditions': this.termsAndConditions});
    }
  }
}
</script>